import { AppointmentType, Appointments, GeneralRequests } from '@prisma/client';
import { Option } from '../interfaces';

export const USE_DEFAULT_TIMEZONE_FOR_DATELINE_CHECK = true;
export const DEFAULT_TIMEZONE = 'US/Pacific';
export const SORTABLE_KEYS = [
  'tattooLocation',
  'createdAt',
  'customer',
  'employee',
] as const satisfies Array<
  // handle non-keyof types in backend
  (keyof Appointments & keyof GeneralRequests) | 'customer' | 'employee'
>;

export const DEFAULT_LENGTH_OPTIONS = [
  {
    label: '30 minutes',
    value: 30,
  },
  {
    label: '1 hour',
    value: 60,
  },
  {
    label: '1 hour and 30 minutes',
    value: 90,
  },
  {
    label: '2 hours',
    value: 120,
  },
  {
    label: '2 hours and 30 minutes',
    value: 150,
  },
  {
    label: '3 hours',
    value: 180,
  },
  {
    label: '3 hours and 30 minutes',
    value: 210,
  },
  {
    label: '4 hours',
    value: 240,
  },
  {
    label: '4 hours and 30 minutes',
    value: 270,
  },
  {
    label: '5 hours',
    value: 300,
  },
  {
    label: '5 hours and 30 minutes',
    value: 330,
  },
  {
    label: '6 hours',
    value: 360,
  },
  {
    label: '6 hours and 30 minutes',
    value: 390,
  },
  {
    label: '7 hours',
    value: 420,
  },
  {
    label: '7 hours and 30 minutes',
    value: 450,
  },
  {
    label: '8 hours',
    value: 480,
  },
];

export const LENGTH_OPTIONS: Partial<Record<AppointmentType, Option[]>> = {
  [AppointmentType.NEW_APPOINTMENT]: DEFAULT_LENGTH_OPTIONS,
  [AppointmentType.WALK_IN]: DEFAULT_LENGTH_OPTIONS,
  [AppointmentType.CONSULTATION]: [
    { label: '15 minutes', value: 15 },
    ...DEFAULT_LENGTH_OPTIONS,
  ],
};

export const FIFTEEN_MIN_LENGTH_OPTIONS = [
  {
    label: '15 minutes',
    value: 15,
  },
  {
    label: '20 minutes',
    value: 20,
  },
  {
    label: '25 minutes',
    value: 25,
  },
  {
    label: '30 minutes',
    value: 30,
  },
  {
    label: '35 minutes',
    value: 35,
  },
  {
    label: '40 minutes',
    value: 40,
  },
  {
    label: '45 minutes',
    value: 45,
  },
  {
    label: '50 minutes',
    value: 50,
  },
  {
    label: '55 minutes',
    value: 55,
  },
  {
    label: '1 hour',
    value: 60,
  },
  {
    label: '1 hour and 15 minutes',
    value: 75,
  },
  {
    label: '1 hour and 30 minutes',
    value: 90,
  },
  {
    label: '1 hour and 45 minutes',
    value: 105,
  },
  {
    label: '2 hours',
    value: 120,
  },
  {
    label: '2 hours and 15 minutes',
    value: 135,
  },
  {
    label: '2 hours and 30 minutes',
    value: 150,
  },
  {
    label: '2 hours and 45 minutes',
    value: 165,
  },
  {
    label: '3 hours',
    value: 180,
  },
  {
    label: '3 hours and 30 minutes',
    value: 210,
  },
  {
    label: '4 hours',
    value: 240,
  },
  {
    label: '4 hours and 30 minutes',
    value: 270,
  },
  {
    label: '5 hours',
    value: 300,
  },
  {
    label: '5 hours and 30 minutes',
    value: 330,
  },
  {
    label: '6 hours',
    value: 360,
  },
  {
    label: '6 hours and 30 minutes',
    value: 390,
  },
  {
    label: '7 hours',
    value: 420,
  },
  {
    label: '7 hours and 30 minutes',
    value: 450,
  },
  {
    label: '8 hours',
    value: 480,
  },
];
